<template>
  <div :style="{direction:$t('direction')}">
    <div class="dashboard">
      <Sidebar />
      <div class="content">
        <Header />
        <div class="dashboard-content">
        <HelperNav />
          <div class="dashboard-wrapper">

            <div class="ar-card">
              <div class="ar-card-header">
                <div class="ar-card-title">
                  حساب های بانکی 
                  <div class="mdi mdi-information-outline"></div>
                </div>
                <div>
                  <add-bank-account>
                    <button class="ar-btn size-sm primary">افزودن کارت بانکی <i class="mdi mdi-plus"></i></button>
                  </add-bank-account>
                </div>
              </div>
              <div class="ar-card-body p-0">
                
                <div class="table-responsive">
                  <table class="table ar-table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>شماره کارت</th>
                        <th>شماره شبا</th>
                        <th>وضعیت</th>
                        <th></th>
                      </tr>
                    </thead>
                    <div v-if="!Object.keys(state_bank_accounts).length" class="wallet-placeholder">هنوز حساب بانکی ایجاد نشده است .</div>
                    <tbody>
                      <tr v-for="(item , key) in state_bank_accounts" :key="key">
                        <th>{{ key+1 }}</th>
                        <td>{{ item.card_number }}</td>
                        <td>IR{{ item.shaba_number }}</td>
                        <td>
                          <span v-if="item.status == 0" class="text-warning">درحال بررسی </span> 
                          <span v-else-if="item.status == 1" class="text-success">تایید شده</span> 
                          <span v-else class="text-danger">رد شده </span> 
                        </td>
                        <td>
                          <i @click="delete_account_id = item.id , delete_modal = true" class="mdi mdi-trash-can-outline font-2 text-danger"></i>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <modal @close="delete_modal = false" :open="delete_modal" :maxWitdh="'600px'">
              
              <div class="ar-card">
                <div class="ar-card-header">
                  <div class="ar-card-title">
                     حذف حساب
                  </div>
                  <span>
                    <i @click="delete_modal = false" class="mdi mdi-close"></i>
                  </span>
                </div>
                <div class="ar-card-body">
                  <div class="ar-form-group">
                    <label for="delete_reason">علت حذف حساب :</label>
                    <textarea v-model="delete_reason" id="delete_reason" rows="5" class="ar-form-control"></textarea>
                  </div>
                </div>
                <div class="ar-card-footer">
                  <button @click="deleteUserBankAccount()" class="ar-btn size-sm danger">حذف</button>
                  <button @click="delete_modal = false" class="ar-btn size-sm outline-primary mx-3">انصراف</button>
                </div>
              </div>
              
            </modal>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Sidebar from './partials/Sidebar'
import Header from './partials/Header'
import HelperNav from './partials/HelperNav'
import Modal from '../../components/Modal.vue'
import AddBankAccount from '../../components/AddBankAccount.vue'
export default {
  name: 'BankAccounts',
  components:{
    Sidebar,
    AddBankAccount,
    Header,
    HelperNav,
    Modal
  },
  data : () => ({
    delete_account_id:null,
    delete_reason:null,
    delete_modal:false,
  }),
  methods:{
    deleteUserBankAccount (){
      this.activeLoading(true)
      const api_token = this.getToken()
      
      this.$axios.post(`deleteUserBankAccount`,{id:this.delete_account_id , delete_reason:this.delete_reason},
      {
        headers: {
          'api_token':api_token
        }
      })
      .then(res => {
        this.StoreBankAccounts(res.data.data)
        this.delete_reason = null
        this.delete_modal = false
        this.activeLoading(false)
      })
      .catch(err => {
        this.activeLoading(false)
      });

    }
  },
  mounted() {
    this.activeLoading(false)
    this.checkAuth()
    this.checkConfirmed()
  }
}
</script>